/**
 * Export New Images (assets) here
 * Don't remove anything here (if not sure)
 **/

import mobile from "../assets/mobile.png";
import cpp from "../assets/cpp.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";

import about01 from "../assets/about01.png";
import about04 from "../assets/about04.png";

import circle from "../assets/circle.svg";

import mongodblogo from "../assets/mongodblogo.svg";
import gmail from "../assets/gmail.webp"
import mypic from "../assets/myp[ic.png"

const images = {
  gmail,

  mobile,
  mypic,
  cpp,

  javascript,
  node,
  mongodblogo,
  react,
  sass,
  about01,
  about04,
  circle,
};

export default images;
